import { Alert } from '@zarya/ui';
import {
  unresolvedAgentsText,
  unresolvedAgentsTitle,
  type ApprovalDetail,
} from './ApprovalsModel';

/**
 * **DEF-39** — os alvos declarados que **não** viram capability (09/09).
 *
 * A release declara os agentes que a identidade quer invocar por slug. Um alvo
 * sem identidade governada correspondente neste tenant — ou com identidade ainda
 * não atribuída, logo sem slug — não vira delegação no contrato: não há alvo que
 * o PDP saiba comparar. Até 08/09 isso acontecia **em silêncio**: a release pedia
 * três, o contrato saía com um, e nada na tela dizia por quê.
 *
 * Fica junto do diff, que é onde a pessoa decide: é a única leitura da tela que
 * fala do que a aprovação NÃO vai emitir, e ela precisa estar do lado do que vai.
 *
 * Vazio é o caso normal, e aí o bloco não existe — um aviso permanente deixa de
 * ser lido.
 */
export function UnresolvedAgents({ detalhe }: { detalhe: ApprovalDetail }) {
  const slugs = detalhe.unresolved_agents ?? [];
  if (!slugs.length) return null;

  return (
    // `role="status"` e não `alert`: é leitura de estado da pendência, não o erro
    // de uma ação — a mesma escolha do bloco «fora do catálogo» em T14.
    <Alert tone="warning" role="status" title={unresolvedAgentsTitle(slugs.length)}>
      {unresolvedAgentsText(slugs)}
    </Alert>
  );
}
